import GeneralTranslations from "../../../Common/ModuleTranslations/en";

export default {
  locale: "en",
  name: "Display",
  translation: { displayName: "Translations" },
  fields: {
    list: [
      ...GeneralTranslations.fields.list,
      {
        fieldName: "active",
        displayName: "is Active",
      },
      {
        fieldName: "conditions",
        displayName: "Conditions",
      },
      {
        fieldName: "position",
        displayName: "Order",
      },
    ],
    form: [
      ...GeneralTranslations.fields.form,
      {
        fieldName: "active",
        displayName: "Active",
        helpText: "Is the display visible on the booking engine?",
      },
      {
        fieldName: "defaultOption",
        displayName: "Opens by default",
      },
      {
        fieldName: "startDate",
        displayName: "Booking window start date",
        placeholder: "Enter a date",
      },
      {
        fieldName: "endDate",
        displayName: "Booking window end date",
        placeholder: "Enter a date",
      },
      {
        fieldName: "entityFilter",
        displayName: "Show only for:",
        optionDisplay: {
          PROPERTY: {
            label: "Property",
          },
          ACCOMMODATION: {
            label: "Accommodation",
          },
        },
        helpText: "It will only be visible for elements of this type",
      },
      {
        fieldName: "tickerFilter",
        displayName: "Show only for the following identifiers (separated by commas):",
      },
      {
        fieldName: "label",
        displayName: "Tag name",
      },
      {
        fieldName: "youTubeURL",
        displayName: "Youtube URL",
      },
      {
        fieldName: "contentType",
        displayName: "Content type",
        optionDisplay: {
          HTML: {
            label: "HTML",
          },
          VIDEO: {
            label: "Video",
          },
          IMAGE: {
            label: "Image",
          },
        },
      },
      {
        fieldName: "content",
        displayName: "Content",
      },
    ],
  },
};
